import firebase from 'firebase/app';

export async function updateLastUserActivity({ projectID, taskID }) {
  const db = firebase.firestore();
  const userID = firebase.auth().currentUser.uid;
  const now = new Date();
  // Update lastUserActivity on project and task
  await db.runTransaction(async transaction => {
    const lastActivityData = {
      [`lastUserActivity.${userID}`]: now,
    };
    const projectRef = db.collection('projects').doc(projectID);
    transaction.update(projectRef, lastActivityData);
    if (taskID) {
      const taskRef = projectRef.collection('tasks').doc(taskID);
      transaction.update(taskRef, lastActivityData);
    }
  });
  // Update user document arrays
  return updateLastActiveArrays({ projectID, taskID });
}

/**
 * Updates the user's lastActiveTasks and lastActiveProjects arrays
 */
export async function updateLastActiveArrays({ projectID, taskID }) {
  const db = firebase.firestore();
  const userID = firebase.auth().currentUser.uid;
  return db.runTransaction(async transaction => {
    const userRef = db.collection('users').doc(userID);
    const userDoc = await transaction.get(userRef);
    const userData = userDoc.data() || {};
    if (taskID) {
      userData.lastActiveTasks = updateRecentIds(
        userData.lastActiveTasks,
        taskID,
        500
      );
    }
    if (projectID) {
      userData.lastActiveProjects = updateRecentIds(
        userData.lastActiveProjects,
        projectID,
        100
      );
    }
    transaction.set(userRef, userData, { merge: true });
  });
}

/**
 * Helper to update recent ID arrays
 */
function updateRecentIds(array, id, limit) {
  let updated = array || [];
  updated = updated.filter(existingId => existingId !== id);
  updated.unshift(id);
  if (updated.length > limit) {
    updated = updated.slice(0, limit);
  }
  return updated;
}
